<template>
  <app-layout>
    <app-layout-header>
      <app-header></app-header>
    </app-layout-header>
    <app-layout-body>
      <div class="page-login">
        <div class="page-login__body">
          <div class="page-login__content">
            <h1 class="page-login__slogan">企业营销推广，用<b>{{ oemInfo.name }}</b></h1>
            <div class="page-login__login-box">
              <app-login></app-login>
            </div>
          </div>
        </div>
      </div>
    </app-layout-body>
    <app-layout-footer></app-layout-footer>
  </app-layout>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppLogin from './AppLogin'

export default {
  name: 'Login',
  components: {
    AppHeader,
    AppLogin
  },

  computed: {
    oemInfo () {
      return this.$store.state.share.oemInfo
    }
  }
}
</script>

<style lang="scss">
.page-login {
  display: flex;
  flex: 1;
  min-height: 580px;

  &__body {
    flex: 1;
    background-image: url('~@/assets/page-login-bg.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  &__content {
    position: relative;
    width: $page-width;
    height: 100%;
    padding: 30px $page-padding;
    margin: 0 auto;
  }

  &__slogan {
    position: absolute;
    top: 50px;
    left: 0;
    margin: 0;
    font-size: 36px;
    font-weight: 400;

    b {
      color: $primary-color;
      font-size: 42px;
    }
  }

  &__login-box {
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -173px;
  }
}
</style>
